import PropTypes from 'prop-types'
import { useHistory } from 'react-router'
import { Button } from 'reactstrap'
import PriceUtil from 'utils/price-util'
import StatusBadge from 'components/atoms/status-badge'
import TimeUtil from 'utils/time-util'

const propTypes = {
  fastSellPayment: PropTypes.object
}

/**
 * Row to display ::FastSellPayment object
 * @param {Object} fastSellPayment - Fast Sell Payment object
 */
const FastSellPaymentTableRow = ({ fastSellPayment }) => {
  const history = useHistory()

  const {
    id,
    fast_sell_product,
    amount,
    credit_bank_account_name,
    credit_bank_account_no,
    credit_bank_name,
    transferred_at,
    payment_status
  } = fastSellPayment

  const handleClickUpdate = () => {
    history.push(`/app/finance/revenues/fast-sell-payments/update/${fast_sell_product?.id}/`)
  }

  return (
    <tr>
      <td>{ id }</td>
      <td>{ fast_sell_product?.name }</td>
      <td>{ PriceUtil.format(amount) }</td>
      <td>{ credit_bank_name }</td>
      <td>{ credit_bank_account_no }</td>
      <td>{ credit_bank_account_name }</td>
      <td>{ TimeUtil.format(transferred_at) }</td>
      <td>
        {
          <StatusBadge
            color={
              payment_status == 'completed'
                ? 'success'
                : 'warning'
            }
            label={ payment_status }
          />
        }
      </td>
      <td>
        <Button
          size={ 'sm' }
          color={ 'primary' }
          onClick={ handleClickUpdate }
        >
          { 'Update' }
        </Button>
      </td>
    </tr>
  )
}

FastSellPaymentTableRow.propTypes = propTypes
export default FastSellPaymentTableRow
